module.exports = __webpack_public_path__ + "img/hp-gloves.c9f22043.png";